import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { WfdCandidateNoteService } from 'src/app/workforce-disruption/candidates/candidate-detail/notes/wfd-note.service';
import * as NoteActions from 'src/app/root-store/account-managers-store/actions/workforce-notes.actions';
import { HttpResponseHelpers } from 'src/app/shared/helpers';
import { selectContractId } from '../account-managers.selectors';

@Injectable()
export class WorkforceNotesEffects {
    loadNotes$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(NoteActions.loadNotes),
            concatLatestFrom(() => this._store.select(selectContractId)),
            switchMap(([action, selectContractId]) => {
                return this._noteService.getNotes(selectContractId).pipe(
                    switchMap((data) => {
                        return of(
                            NoteActions.loadNotesSuccess({
                                notes: data
                            })
                        );
                    }),
                    catchError((error: unknown) =>
                        of(
                            NoteActions.loadNotesFailure({
                                error: HttpResponseHelpers.parseErrorResponse(error)
                            })
                        )
                    )
                );
            })
        );
    });

    addNote$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(NoteActions.addNote),
            concatLatestFrom(() => this._store.select(selectContractId)),
            switchMap(([action, selectContractId]) =>
                this._noteService.addNote(action.newNote, selectContractId).pipe(
                    map((result) => NoteActions.addNotesSuccess({ returnNote: result })),
                    catchError((error: unknown) =>
                        of(
                            NoteActions.addNotesFailure({
                                error: HttpResponseHelpers.parseErrorResponse(error)
                            })
                        )
                    )
                )
            )
        );
    });

    constructor(
        private readonly _actions$: Actions,
        private readonly _noteService: WfdCandidateNoteService,
        private readonly _sanitizer: DomSanitizer,
        private readonly _store: Store<{}>
    ) {}
}
